import Module from '../../utils/modules/Module';

export default class AccordionModule extends Module {
  constructor(options) {
    super(options)

    this.init();
  }

  init() {
    // Event listener
    document.querySelectorAll('.accordion-trigger').forEach((el) => {
      el.addEventListener('click', this.onClickOpen);
      el.addEventListener('keypress', this.onClickOpen);
    });
    document.querySelectorAll('.disclaimer .accordion-trigger').forEach((el) => {
      el.click();
    });
  }

  /** ------------------------------
   * Events
   --------------------------------- */
  onClickOpen(e) {
    let $el = e.currentTarget;
    let $parent = $el.closest('.accordion-item');
    let $container = $el.nextElementSibling;
    let $inner = $container.querySelector('.accordion-content-inner');

    $el.blur();
    $parent.classList.toggle('is-closed');

    if ($parent.classList.contains('is-closed')) {
      $parent.querySelectorAll('[aria-expanded="true"]').forEach((el) => {
        el.setAttribute('aria-expanded', 'false');
      });
      $parent.querySelectorAll('div[aria-hidden="false"]').forEach((el) => {
        el.setAttribute('aria-hidden', 'true');
      });

      $container.style.height = '0px';
      $el.querySelector('.accordion-icon-tx-inner').innerHTML = $el.querySelector('.accordion-icon-tx').dataset.close;
    } else {
      $parent.querySelectorAll('[aria-expanded="false"]').forEach((el) => {
        el.setAttribute('aria-expanded', 'true');
      });
      $parent.querySelectorAll('div[aria-hidden="true"]').forEach((el) => {
        el.setAttribute('aria-hidden', 'false');
      });

      $container.style.height = $inner.clientHeight + 'px';
      $el.querySelector('.accordion-icon-tx-inner').innerHTML = $el.querySelector('.accordion-icon-tx').dataset.open;
    }
  }
}
